import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import adConfig from '../../lib/advertising/slots/ros-top-mpu';
import { getCurrentClubIncludesAdverts } from '../../store/clubs/selectors';
import Advert from './advert';

const RosTopMpu = ({ className, includeAdverts, style: customStyle }, uid) => {
  if (!includeAdverts) return null;

  const adProps = {};
  if (uid) {
    adProps.key = uid;
  }

  return <Advert adConfig={adConfig} className={className} style={customStyle} {...adProps} />;
};

RosTopMpu.propTypes = {
  className: PropTypes.string,
  includeAdverts: PropTypes.bool.isRequired,
  style: PropTypes.shape(),
  uid: PropTypes.string,
};
RosTopMpu.defaultProps = {
  className: null,
  style: {},
  uid: null,
};
const mapStateToProps = (state) => ({
  includeAdverts: getCurrentClubIncludesAdverts(state),
});
export default connect(mapStateToProps)(RosTopMpu);
